import { RouterModule, Routes } from '@angular/router';

import { InspectionResolver } from '../../utils/inspection.resolver';
import { MakePointNotApplicablePageComponent } from '../pages/notApplicable.component';
import { NgModule } from '@angular/core';
import { PointEditJsonPageComponent } from '../pages/edit-json.component';
import { PointEditNotesPageComponent } from '../pages/edit-notes.component';
import { PointEditPageComponent } from '../pages/edit.component';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';
import { PermissionGuard } from '../../utils/permission.guard';
import { environment } from '../../../environments/environment';

const appRoute = environment.applicationRoute;

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver, inspection: InspectionResolver },
    children: [
      {
        path: appRoute + '/inspections/:inspectionId/points/:pointId/notavailable',
        component: MakePointNotApplicablePageComponent
      },
      { path: appRoute + '/inspections/:inspectionId/points/:pointId/edit', component: PointEditPageComponent },
      { path: appRoute + '/inspections/:inspectionId/points/:pointId/editnotes', component: PointEditNotesPageComponent },
      { path: appRoute + '/inspections/:inspectionId/points/:pointId/editjson', component: PointEditJsonPageComponent }
    ]
  },
  {
    path: '',
    resolve: { inspection: InspectionResolver },
    children: [
      {
        path: appRoute + '/templates/:inspectionId/points/:pointId/edit',
        component: PointEditPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/templates/:inspectionId/points/:pointId/editnotes',
        component: PointEditNotesPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/templates/:inspectionId/points/:pointId/editjson',
        component: PointEditJsonPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PointEditorRoutingModule {}
export const routedComponents = [
  PointEditPageComponent,
  MakePointNotApplicablePageComponent,
  PointEditNotesPageComponent,
  PointEditJsonPageComponent
];
